import reducer from './reducers';

import * as uiActions from './actions';
import * as uiTypes from './types';

export { uiActions, uiTypes };

export default reducer;
